import { render, staticRenderFns } from "./display-device-details-inline.vue?vue&type=template&id=dd640bb0&"
import script from "./display-device-details-inline.vue?vue&type=script&lang=js&"
export * from "./display-device-details-inline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./display-device-details-inline-i18n.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fweb%2Fsrc%2Fcomponents%2Fgeneral%2Fdisplay-device-details-inline.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports